import React from 'react'
import Context from './context'
import hoistNonReactStatic from 'hoist-non-react-statics'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

function defaultAuthToProps(context) {
  return {
    auth: context,
  }
}

const withAuth = mapper => Component => {
  class WithAuth extends React.Component {
    render() {
      return (
        <Context.Consumer>
          {context => {
            const props = Object.assign(
              {},
              typeof mapper === 'function'
                ? mapper(context)
                : defaultAuthToProps(context),
              this.props
            )
            return <Component {...props} />
          }}
        </Context.Consumer>
      )
    }
  }
  WithAuth.displayName = `WithAuth(${getDisplayName(Component)})`
  hoistNonReactStatic(WithAuth, Component)
  return WithAuth
}

export default withAuth
